import React from 'react';
import { bool, func, object, oneOf, shape, string } from 'prop-types';
import { MQ_MIDLARGE, MQ_MEDIUM } from 'constants/mq';

import styles from './styles';

// our cover images will be cropped to a specific aspect ratio
export const FIGURE_SIZING = {
  maxWidth: 1318,
  width: 2636,
  height: 1318,
  sourceSizes: [
    {
      media: MQ_MIDLARGE,
      layoutWidth: {
        value: 1318,
        units: 'px'
      }
    },
    {
      media: MQ_MEDIUM,
      layoutWidth: {
        value: 768,
        units: 'px'
      }
    },
    {
      layoutWidth: {
        value: 320,
        units: 'px'
      }
    }
  ]
};

// Cover gallery will have different image sizes than in-post
// CLEANUP: THIS IS NEVER APPLIED TO THE GALLERY!
export const GALLERY_IMAGE_SPECS = {
  slideImage: {
    maxSizeWidth: 1318,
    sourceSizes: [
      {
        media: MQ_MIDLARGE,
        layoutWidth: { units: 'px', value: 1318 }
      },
      { layoutWidth: { units: 'vw', value: 100 } }
    ]
  },
  previewImage: {
    maxSizeWidth: 1318,
    sourceSizes: [{ layoutWidth: { units: 'vw', value: 100 } }]
  }
};

function CoverMedia(props) {
  const { components, type, data, post, hasPrism } = props;
  const MediaElement = components[type] || (() => null);
  const mediaProps = {
    ...data,
    ...{ post },
    coverMedia: true,
    hasPrism,
    ...(type === 'image' && {
      ...FIGURE_SIZING,
      placement: 'cover',
      variant: 'extra-wide',
      hasLazyImage: false
    }),
    ...(type === 'gallery' && {
      variant: 'slider',
      imageSpecs: GALLERY_IMAGE_SPECS
    })
  };

  return (
    <div className={`CoverMedia CoverMedia--${type}`}>
      <style jsx>{styles}</style>
      <MediaElement {...mediaProps} />
    </div>
  );
}

CoverMedia.propTypes = {
  components: shape({ gallery: func, image: func, video: func }).isRequired,
  type: oneOf(['gallery', 'image', 'video']).isRequired,
  data: shape({}).isRequired,
  hasPrism: bool,
  post: shape({
    ads: shape({
      targeting: object
    }),
    canonical: string,
    title: string
  }).isRequired
};

CoverMedia.defaultProps = {
  hasPrism: false
};

export default CoverMedia;
